import { createSlice } from "@reduxjs/toolkit"
import { revertAllMarketing } from "../actions/user"

const initialState = {
  wineOfTheMonth: {
    id: null,
    videoThumbnailImage: null,
    bottleimage: null,
    flavourImages: [],
    listWineMonthData: [],
    getSingleWineMonthData: {}
  },
  raffleContestData: {
    id: null,
    isFormSubmitted: false,
    raffleListData: [],
    getSingleRaffle: {}
  },
  menu: {
    linkCategory: {
      list: ""
    },
    archived: false,
    menuItemImageId: "",
    menu_Category_ID: "",
    menu_item_ID: "",
    foodItem: {},
    menuPeriod: [],
    barMenuPeriod: [],
    wineMenuPeriod: [],
    spiritData: [],
    isArchive: false,
    newSpiritCount: {},
    bar_category: null,
    menuSubCategory: [],
    menuPreviewData: {},
    soundbiteVoiceIds: [],
    reviewMenuCategories: [],
    reviewMenuPeriod: [],
    reviewBarMenuPeriod: [],
    reviewWineMenuPeriod: [],
    reviewSpiritData: [],
    reviewMenuSubCategory: [],
    menuUploadStatus: "",
    uploadJobId: null,
    uploadProgress: null,
    isMenuUploading: false
  },
  leaderboard: {
    data: {},
    userId: "",
    userRank: 1,
    singleUserData: {}
  },
  featureItemMonth: {
    featureItemId: ""
  },
  gamificationData: [],
  quizLeaderBoardData: [],
  didYouKnowImage: [],
  historyMedia: {
    icon: null,
    image: null
  },
  weeklyChallengeList: [],
  nextWeeklyChallengeList: [],
  lastWeeklyChallengeList: [],
  previousToLastWeeklyChallengeList: [],
  weeklyChallengeData: {},
  weeklyChallengeId: "",
  weeklyQuizList: [],
  nextWeeklyQuizList: [],
  lastWeeklyQuizList: [],
  previousToLastWeeklyQuizList: [],
  weeklyQuizId: "",
  weeklyQuizData: {},
  isContestEdited: false,
  challengeQuestions: [],
  challengeQuestionsCount: 0,
  quizQuestions: [],
  quizQuestionsCount: 0,
  weeklyCategoryList: [],
  weeklyQuestionBankData: [],
  menuList: [],
  soundbites: {},
  commentsData: {},
  statusChanged: false,
  historyData: [],
  didYouKnowData: []
}

const marketing = createSlice({
  name: "marketing",
  initialState: initialState,
  extraReducers: (builder) => builder.addCase(revertAllMarketing, () => initialState),
  reducers: {
    setWineMonthVideoThumbnail: (state, action) => {
      state.wineOfTheMonth.videoThumbnailImage = action.payload
    },
    setWineMonthListData: (state, action) => {
      state.wineOfTheMonth.listWineMonthData = action.payload
    },
    setWineOfTheMonthID: (state, action) => {
      state.wineOfTheMonth.id = action.payload
    },
    setGetSingleWineMonthData: (state, action) => {
      state.wineOfTheMonth.getSingleWineMonthData = action.payload
    },
    setIsEditWineFormSubmitted: (state, action) => {
      state.raffleContestData.isFormSubmitted = action.payload
    },
    setRaffleListData: (state, action) => {
      state.raffleContestData.raffleListData = action.payload
    },
    setRaffleID: (state, action) => {
      state.raffleContestData.id = action.payload
    },
    setRaffleSingleData: (state, action) => {
      state.raffleContestData.getSingleRaffle = action.payload
    },
    setWineMonthPDFThumbnail: (state, action) => {
      state.wineOfTheMonth.bottleimage = action.payload
    },
    setMenuLink: (state, action) => {
      state.menu.linkCategory = action.payload
    },
    setArchivedMenu: (state, action) => {
      state.menu.archived = action.payload
    },
    setFilterListValue: (state, action) => {
      state.menu.linkCategory.list = action.payload
    },
    setMenuPeriodData: (state, action) => {
      state.menu.menuPeriod = action.payload
    },
    setMenuCategoryId: (state, action) => {
      state.menu.menu_Category_ID = action.payload
    },
    setBarCategory: (state, action) => {
      state.menu.bar_category = action.payload
    },
    setMenuImageId: (state, action) => {
      state.menu.menuItemImageId = action.payload
    },
    setMenuItemId: (state, action) => {
      state.menu.menu_item_ID = action.payload
    },
    setFoodItemsDetail: (state, action) => {
      state.menu.foodItem = action.payload
    },
    setFeatureItemId: (state, action) => {
      state.featureItemMonth.featureItemId = action.payload
    },
    setTastingNotesImages: (state, action) => {
      if (action.payload?.length === 0) state.wineOfTheMonth.flavourImages = action.payload
      state.wineOfTheMonth.flavourImages[action.payload.index] = action.payload.id
    },
    setLoaderBoardData: (state, action) => {
      state.leaderboard.data = action.payload
    },
    setUserId: (state, action) => {
      state.leaderboard.userId = action.payload
    },
    setUserRank: (state, action) => {
      state.leaderboard.userRank = action.payload
    },
    setSingleUserDataGraph: (state, action) => {
      state.leaderboard.singleUserData = action.payload
    },
    setBarMenuPeriodData: (state, action) => {
      state.menu.barMenuPeriod = action.payload
    },
    setWineMenuPeriodData: (state, action) => {
      state.menu.wineMenuPeriod = action.payload
    },
    setSpiritData: (state, action) => {
      state.menu.spiritData = action.payload
    },
    setisArchive: (state, action) => {
      state.menu.isArchive = action.payload
    },
    setNewSpiritCount: (state, action) => {
      state.menu.newSpiritCount = action.payload
    },
    setGamificationLoaderBoardData: (state, action) => {
      state.gamificationData = action.payload
    },
    setMenuSubCategory: (state, action) => {
      state.menu.menuSubCategory = action.payload
    },
    setQuizLeaderBoardData: (state, action) => {
      state.quizLeaderBoardData = action.payload
    },
    setDidYouKnowImage: (state, action) => {
      state.didYouKnowImage[action.payload.index] = action.payload.id
    },
    resetDidYouKnowImage: (state) => {
      state.didYouKnowImage = []
    },
    setHistoryMedia: (state, action) => {
      if (!state.historyMedia) state.historyMedia = {}
      state.historyMedia[action.payload.type] = action.payload.id
    },
    resetHistoryMedia: (state) => {
      state.historyMedia = {
        icon: null,
        image: null
      }
    },
    setWeeklyChallengeList: (state, action) => {
      state.weeklyChallengeList = action.payload
    },
    setNextWeeklyChallengeData: (state, action) => {
      state.nextWeeklyChallengeList = action.payload
    },
    setLastWeeklyChallengeData: (state, action) => {
      state.lastWeeklyChallengeList = action.payload
    },
    setPreviousToLastWeeklyChallengeData: (state, action) => {
      state.previousToLastWeeklyChallengeList = action.payload
    },
    setWeeklyChallengeData: (state, action) => {
      state.weeklyChallengeData = action.payload
    },
    setWeeklyChallengeId: (state, action) => {
      state.weeklyChallengeId = action.payload
    },
    setWeeklyQuizList: (state, action) => {
      state.weeklyQuizList = action.payload
    },
    setWeeklyQuizId: (state, action) => {
      state.weeklyQuizId = action.payload
    },
    setNextWeeklyQuizData: (state, action) => {
      state.nextWeeklyQuizList = action.payload
    },
    setLastWeeklyQuizData: (state, action) => {
      state.lastWeeklyQuizList = action.payload
    },
    setPreviousToLastWeeklyQuizData: (state, action) => {
      state.previousToLastWeeklyQuizList = action.payload
    },
    setWeeklyQuizData: (state, action) => {
      state.weeklyQuizData = action.payload
    },
    setIsContestEdited: (state, action) => {
      state.isContestEdited = action.payload
    },
    setViewChallengeQuestions: (state, action) => {
      state.challengeQuestions = action.payload
    },
    setChallengeQuestionsCount: (state, action) => {
      state.challengeQuestionsCount = action.payload
    },
    setViewQuizQuestions: (state, action) => {
      state.quizQuestions = action.payload
    },
    setQuizQuestionsCount: (state, action) => {
      state.quizQuestionsCount = action.payload
    },
    setWeeklyCategoryList: (state, action) => {
      state.weeklyCategoryList = action.payload
    },
    setWeeklyQuestionBank: (state, action) => {
      state.weeklyQuestionBankData = action.payload
    },
    setMenuList: (state, action) => {
      state.menuList = action.payload
    },
    setSoundbites: (state, action) => {
      state.soundbites = action.payload
    },
    setMenuPreviewData: (state, action) => {
      state.menu.menuPreviewData = action.payload
    },
    setCommentsData: (state, action) => {
      state.commentsData = action.payload
    },
    setStatusChanged: (state, action) => {
      state.statusChanged = action.payload
    },
    setHistoryData: (state, action) => {
      state.historyData = action.payload
    },
    setDidYouKnowData: (state, action) => {
      state.didYouKnowData = action.payload
    },
    setSoundbiteVoiceIds: (state, action) => {
      state.menu.soundbiteVoiceIds = action.payload
    },
    setReviewMenuCategories: (state, action) => {
      state.menu.reviewMenuCategories = action.payload
    },
    setReviewMenuPeriodData: (state, action) => {
      state.menu.reviewMenuPeriod = action.payload
    },
    setReviewBarMenuPeriodData: (state, action) => {
      state.menu.reviewBarMenuPeriod = action.payload
    },
    setReviewWineMenuPeriodData: (state, action) => {
      state.menu.reviewWineMenuPeriod = action.payload
    },
    setReviewSpiritData: (state, action) => {
      state.menu.reviewSpiritData = action.payload
    },
    setReviewMenuSubCategory: (state, action) => {
      state.menu.reviewMenuSubCategory = action.payload
    },
    setMenuUploadStatus: (state, action) => {
      state.menu.menuUploadStatus = action.payload
    },
    setUploadJobId: (state, action) => {
      state.menu.uploadJobId = action.payload
    },
    setUploadProgress: (state, action) => {
      state.menu.uploadProgress = action.payload
    },
    setIsMenuUploading: (state, action) => {
      state.menu.isMenuUploading = action.payload
    }
  }
})

export default marketing
export const marketingActions = marketing.actions
